﻿import { GuiDetailGeneric } from "../../GuiDetailGeneric";

export class GuiDetailKostenstelle extends GuiDetailGeneric {
    constructor() {
        super("Kostenstelle");
    }
}
